/* ==========================================================================
   AxionfitDance — interacciones propias
   Guard de ejecución única: el mismo <script src> aparece en varias secciones
   y el navegador ejecuta CADA etiqueta aunque solo descargue el archivo una vez.
   ========================================================================== */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  /* --------------------------------------------------------------- textos
     Los textos visibles vienen traducidos desde Liquid (snippets/mt-textos).
     El segundo argumento es el respaldo, por si el snippet no llegara. */
  var T = window.mtTextos || {};
  /* separador decimal del idioma: en inglés 24.3, en español 24,3 */
  var SEP = T.decimal || ',';
  function num(n) { return String(n).replace('.', SEP); }
  function txt(clave, respaldo, valores) {
    var s = T[clave] || respaldo;
    if (valores) for (var k in valores) s = s.replace(k, valores[k]);
    return s;
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var animar = !reduce && 'IntersectionObserver' in window;

  /* Enciende el modo animación lo antes posible (el script va con defer, así que
     esto corre antes de DOMContentLoaded). Si algo impide que el observador
     dispare, la red de seguridad de abajo lo apaga y todo queda visible. */
  if (animar) {
    document.documentElement.classList.add('mt-anim');
    setTimeout(function () {
      if (document.querySelector('.mt-reveal.mt-visible')) return; // el observador funciona
      document.documentElement.classList.remove('mt-anim');
    }, 2500);
  }

  /* --- helper: marca un elemento como ya inicializado (idempotencia) ------ */
  function nuevo(el) {
    if (!el || el.dataset.mtInit === '1') return false;
    el.dataset.mtInit = '1';
    return true;
  }

  /* ---------------------------------------------------------------- reveals */
  var observador = null;
  function initReveals() {
    var items = document.querySelectorAll('.mt-reveal:not([data-mt-rev])');
    if (!items.length) return;
    if (!animar) {
      items.forEach(function (el) { el.dataset.mtRev = '1'; el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          var d = parseInt(el.getAttribute('data-mt-delay') || '0', 10);
          setTimeout(function () { el.classList.add('mt-visible'); }, d);
          observador.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    }
    items.forEach(function (el) { el.dataset.mtRev = '1'; observador.observe(el); });
  }

  /* --------------------------------------------------- carrusel de productos */
  function initCarruseles() {
    document.querySelectorAll('[data-mt-carrusel]').forEach(function (raiz) {
      if (!nuevo(raiz)) return;
      var pista = raiz.querySelector('.mt-prod__wrap');
      var ant = raiz.querySelector('[data-mt-ant]');
      var sig = raiz.querySelector('[data-mt-sig]');
      if (!pista) return;
      function salto() {
        var t = pista.querySelector('.mt-card');
        return t ? t.getBoundingClientRect().width + 22 : 300;
      }
      if (ant) ant.addEventListener('click', function () { pista.scrollBy({ left: -salto() * 2, behavior: 'smooth' }); });
      if (sig) sig.addEventListener('click', function () { pista.scrollBy({ left: salto() * 2, behavior: 'smooth' }); });
    });
  }

  /* ------------------------- elige tu tacón (82) — desplegable por delegación
     Delegación en document: así funciona aunque el editor redibuje la sección
     y no dependemos de que un init llegue a correr. */
  function initTacon() {
    if (window.__mtTaconDelegado) return;
    window.__mtTaconDelegado = true;

    function puntos(cont, n) {
      if (!cont) return;
      [].forEach.call(cont.children, function (p, i) { p.classList.toggle('on', i < n); });
    }

    function cerrar(caja) {
      caja.classList.remove('mt-abierto');
      caja.querySelectorAll('.mt-tac__op').forEach(function (o) {
        o.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      // botón de cerrar del panel
      var equis = e.target.closest('[data-mt-tacon-cerrar]');
      if (equis) {
        var cajaX = equis.closest('.mt-tac__caja');
        if (cajaX) cerrar(cajaX);
        return;
      }

      var op = e.target.closest('.mt-tac__op');
      if (!op) return;
      var caja = op.closest('.mt-tac__caja');
      if (!caja) return;

      var activo = caja.querySelector('.mt-tac__op[aria-expanded="true"]');

      // pulsar el mismo que ya está abierto -> se pliega hacia arriba
      if (activo === op && caja.classList.contains('mt-abierto')) {
        cerrar(caja);
        return;
      }

      caja.querySelectorAll('.mt-tac__op').forEach(function (o) {
        o.setAttribute('aria-expanded', o === op ? 'true' : 'false');
      });

      // la foto completa del tacón elegido pasa al fondo del panel
      var fondo = caja.querySelector('[data-mt-tacon-fondo]');
      var foto = op.querySelector('.mt-tac__foto img');
      // currentSrc viene vacío si la imagen aún no ha cargado (loading="lazy"),
      // así que caemos al atributo src, que siempre está puesto.
      var ruta = foto ? (foto.currentSrc || foto.getAttribute('src')) : '';
      if (fondo && ruta) fondo.style.backgroundImage = 'url("' + ruta + '")';

      var cm = caja.querySelector('[data-mt-tacon-cm]');
      var tp = caja.querySelector('[data-mt-tacon-tipo]');
      var ds = caja.querySelector('[data-mt-tacon-desc]');
      if (cm) cm.textContent = op.getAttribute('data-cm') || '';
      if (tp) tp.textContent = op.getAttribute('data-tipo') || '';
      if (ds) ds.textContent = op.getAttribute('data-desc') || '';
      puntos(caja.querySelector('[data-mt-tacon-altura]'), parseInt(op.getAttribute('data-altura'), 10) || 0);
      puntos(caja.querySelector('[data-mt-tacon-estab]'), parseInt(op.getAttribute('data-estab'), 10) || 0);

      caja.classList.add('mt-abierto');
    });
  }

  /* ------------------------------- app móvil: barra inferior + mega menú */
  function initApp() {
    document.querySelectorAll('[data-mt-app]').forEach(function (raiz) {
      if (!nuevo(raiz)) return;
      var cajon = raiz.querySelector('.mt-app__cajon');
      var velo = raiz.querySelector('.mt-app__velo');
      // Se buscan en TODO el documento: el botón de menú vive también en la
      // cabecera, que está fuera de este bloque.
      var abridores = document.querySelectorAll('[data-mt-abrir-menu]');
      var cerradores = document.querySelectorAll('[data-mt-cerrar-menu]');
      if (!cajon || !velo) return;

      var ultimoFoco = null;

      function abrir() {
        ultimoFoco = document.activeElement;
        velo.hidden = false;
        cajon.hidden = false;
        // fuerza un reflow para que la transición arranque desde fuera de pantalla
        void cajon.offsetWidth;
        velo.classList.add('mt-abierto');
        cajon.classList.add('mt-abierto');
        document.documentElement.classList.add('mt-menu-abierto');
        abridores.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        var primero = cajon.querySelector('.mt-app__pestana');
        if (primero) primero.focus();
      }

      function cerrar() {
        velo.classList.remove('mt-abierto');
        cajon.classList.remove('mt-abierto');
        document.documentElement.classList.remove('mt-menu-abierto');
        abridores.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        setTimeout(function () {
          if (!cajon.classList.contains('mt-abierto')) { velo.hidden = true; cajon.hidden = true; }
        }, reduce ? 0 : 400);
        if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
      }

      abridores.forEach(function (b) { b.addEventListener('click', abrir); });
      cerradores.forEach(function (b) { b.addEventListener('click', cerrar); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && cajon.classList.contains('mt-abierto')) cerrar();
      });

      // pestañas Categorías / Menú
      var pestanas = raiz.querySelectorAll('[data-mt-pestana]');
      pestanas.forEach(function (p) {
        p.addEventListener('click', function () {
          var destino = p.getAttribute('data-mt-pestana');
          pestanas.forEach(function (o) {
            o.setAttribute('aria-selected', o === p ? 'true' : 'false');
          });
          raiz.querySelectorAll('[data-mt-panel]').forEach(function (panel) {
            panel.classList.toggle('mt-app__panel--activo', panel.getAttribute('data-mt-panel') === destino);
          });
          var cuerpo = raiz.querySelector('.mt-app__cuerpo');
          if (cuerpo) cuerpo.scrollTop = 0;
        });
      });

      // desplegables de categorías con subniveles
      raiz.querySelectorAll('[data-mt-desplegar]').forEach(function (b) {
        b.addEventListener('click', function () {
          var grupo = b.closest('[data-mt-grupo]');
          if (!grupo) return;
          var abierto = grupo.dataset.abierto === '1';
          grupo.dataset.abierto = abierto ? '0' : '1';
          b.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        });
      });

      // contador del carrito siempre al día
      function refrescaCarrito() {
        var globos = raiz.querySelectorAll('[data-mt-cuenta-carrito]');
        if (!globos.length) return;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            globos.forEach(function (g) {
              g.textContent = c.item_count;
              g.hidden = c.item_count === 0;
            });
          })
          .catch(function () { /* sin conexión: se queda el valor del servidor */ });
      }
      refrescaCarrito();
      window.addEventListener('pageshow', refrescaCarrito);
      document.addEventListener('click', function (e) {
        var boton = e.target.closest && e.target.closest('[name="add"], form[action*="/cart"] [type="submit"]');
        if (boton) setTimeout(refrescaCarrito, 900);
      });
    });
  }

  /* --------------------------------------------------- anatomía / hotspots (17) */
  function initAnatomia() {
    document.querySelectorAll('[data-mt-anatomia]').forEach(function (raiz) {
      if (!nuevo(raiz)) return;
      var puntos = raiz.querySelectorAll('.mt-anat__punto');
      var items = raiz.querySelectorAll('.mt-anat__item');
      if (!items.length) return;

      var visor = raiz.querySelector('[data-mt-anat-visor]');
      var volver = raiz.querySelector('[data-mt-anat-volver]');

      function capa(clave) {
        return visor ? visor.querySelector('[data-mt-capa="' + clave + '"]') : null;
      }

      /* Cambia la foto grande. 'base' es la vista general; un número es la foto
         de detalle de ese punto. Si ese punto no tiene foto, se queda la que hay. */
      function verVista(clave) {
        if (!visor) return;
        var destino = capa(clave);
        if (!destino) return;
        visor.querySelectorAll('.mt-anat__capa').forEach(function (c) {
          c.classList.toggle('mt-anat__capa--activa', c === destino);
        });
        visor.setAttribute('data-vista', clave);
        if (volver) volver.hidden = (clave === 'base');
      }

      function activar(i, cambiarFoto) {
        items.forEach(function (it, k) { it.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        puntos.forEach(function (p, k) { p.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
        if (cambiarFoto) verVista(String(i));
      }

      items.forEach(function (it, i) {
        it.addEventListener('click', function () { activar(i, true); });
      });
      puntos.forEach(function (p, i) {
        p.addEventListener('click', function () {
          activar(i, true);
          if (window.innerWidth < 990 && items[i]) items[i].scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        /* en ordenador el ratón solo resalta el texto: la foto no salta sola */
        p.addEventListener('mouseenter', function () { if (window.innerWidth >= 990) activar(i, false); });
      });

      if (volver) {
        volver.addEventListener('click', function () { verVista('base'); });
      }

      activar(0, false);
    });
  }

  /* ------------------------------------------------------- cifras count-up (44) */
  function initCifras() {
    document.querySelectorAll('[data-mt-cifra]').forEach(function (el) {
      if (!nuevo(el)) return;
      var destino = parseFloat(el.getAttribute('data-mt-cifra'));
      if (isNaN(destino)) return;
      var pre = el.getAttribute('data-pre') || '';
      var post = el.getAttribute('data-post') || '';
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);

      function formatea(n) {
        return pre + n.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec }) + post;
      }
      if (!animar) { el.textContent = formatea(destino); return; }
      el.textContent = formatea(0);

      var arrancado = false;
      // Red de seguridad: si el observador nunca dispara, la cifra no se queda en 0
      setTimeout(function () { if (!arrancado) el.textContent = formatea(destino); }, 2500);

      var io = new IntersectionObserver(function (ent) {
        ent.forEach(function (e) {
          if (!e.isIntersecting) return;
          arrancado = true;
          io.unobserve(el);
          var ini = null, dur = 1600;
          function paso(t) {
            if (!ini) ini = t;
            var p = Math.min((t - ini) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = formatea(destino * eased);
            if (p < 1) requestAnimationFrame(paso);
            else el.textContent = formatea(destino);
          }
          requestAnimationFrame(paso);
        });
      }, { threshold: 0.4 });
      io.observe(el);
    });
  }

  /* -------------------------------------------------------------- quiz (79) */
  function initQuiz() {
    document.querySelectorAll('[data-mt-quiz]').forEach(function (raiz) {
      if (!nuevo(raiz)) return;
      var pasos = raiz.querySelectorAll('.mt-quiz__paso');
      var barra = raiz.querySelector('.mt-quiz__barra i');
      var reiniciar = raiz.querySelector('[data-mt-quiz-reiniciar]');
      var resultados = [];
      raiz.querySelectorAll('[data-mt-quiz-res]').forEach(function (n) {
        resultados.push({
          clave: (n.getAttribute('data-clave') || '').toLowerCase(),
          titulo: n.getAttribute('data-titulo') || '',
          desc: n.getAttribute('data-desc') || '',
          cta: n.getAttribute('data-cta') || '',
          url: n.getAttribute('data-url') || '#'
        });
      });
      if (!pasos.length || !resultados.length) return;

      var respuestas = [];
      var indice = 0;

      function mostrar(i) {
        pasos.forEach(function (p, k) { p.classList.toggle('mt-activo', k === i); });
        // Animamos transform (va por GPU), nunca width
        if (barra) barra.style.transform = 'scaleX(' + (i / (pasos.length - 1)).toFixed(3) + ')';
        if (reiniciar) reiniciar.hidden = i !== pasos.length - 1;
      }

      function resolver() {
        var cuenta = {};
        respuestas.forEach(function (r) { cuenta[r] = (cuenta[r] || 0) + 1; });
        var mejor = respuestas[respuestas.length - 1] || resultados[0].clave;
        var max = 0;
        Object.keys(cuenta).forEach(function (k) { if (cuenta[k] > max) { max = cuenta[k]; mejor = k; } });
        var r = resultados.filter(function (x) { return x.clave === mejor; })[0] || resultados[0];
        var caja = raiz.querySelector('[data-mt-quiz-salida]');
        if (!caja) return;
        caja.innerHTML =
          '<div class="mt-quiz__res-eti"></div>' +
          '<div class="mt-quiz__res-t"></div>' +
          '<p class="mt-quiz__res-d mt-body"></p>' +
          '<a class="mt-btn mt-btn--principal mt-magnetico" href="' + r.url.replace(/"/g, '&quot;') + '"></a>';
        caja.querySelector('.mt-quiz__res-eti').textContent = raiz.getAttribute('data-etiqueta-resultado') || 'Tu resultado';
        caja.querySelector('.mt-quiz__res-t').textContent = r.titulo;
        caja.querySelector('.mt-quiz__res-d').textContent = r.desc;
        caja.querySelector('.mt-btn').textContent = r.cta;
      }

      raiz.querySelectorAll('.mt-quiz__op').forEach(function (b) {
        b.addEventListener('click', function () {
          respuestas[indice] = (b.getAttribute('data-valor') || '').toLowerCase();
          indice++;
          if (indice >= pasos.length - 1) { indice = pasos.length - 1; resolver(); }
          mostrar(indice);
        });
      });
      if (reiniciar) {
        reiniciar.addEventListener('click', function () {
          respuestas = []; indice = 0; mostrar(0);
        });
      }
      mostrar(0);
    });
  }

  /* --------------------------------------------------------------- FAQ (80) */
  function initFaq() {
    document.querySelectorAll('[data-mt-faq]').forEach(function (raiz) {
      if (!nuevo(raiz)) return;
      raiz.querySelectorAll('.mt-faq__item').forEach(function (item, i) {
        var b = item.querySelector('.mt-faq__b');
        if (!b) return;
        if (i === 0) { item.dataset.abierto = '1'; b.setAttribute('aria-expanded', 'true'); }
        b.addEventListener('click', function () {
          var abierto = item.dataset.abierto === '1';
          raiz.querySelectorAll('.mt-faq__item').forEach(function (o) {
            o.dataset.abierto = '0';
            var ob = o.querySelector('.mt-faq__b');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          });
          if (!abierto) { item.dataset.abierto = '1'; b.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  /* ------------------------------------------------------------ CTA magnético */
  function initMagnetico() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.mt-magnetico').forEach(function (b) {
      if (!nuevo(b)) return;
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / r.width;
        var y = (e.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + (x * 8).toFixed(2) + 'px,' + (y * 6).toFixed(2) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }

  /* ---------------------------------------------- página de producto: galería */
  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (raiz) {
      if (!nuevo(raiz)) return;
      var principal = raiz.querySelector('[data-mt-galeria-principal]');
      var minis = raiz.querySelectorAll('.mt-pp__mini');
      if (!principal || !minis.length) return;
      minis.forEach(function (m) {
        m.addEventListener('click', function () {
          var src = m.getAttribute('data-src');
          if (src) principal.src = src;
          var alt = m.getAttribute('data-alt');
          principal.alt = alt || '';
          minis.forEach(function (o) { o.setAttribute('aria-current', o === m ? 'true' : 'false'); });
        });
      });
    });
  }

  /* -------------------------------------------- página de producto: variantes */
  function initVariantes() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
      if (!nuevo(raiz)) return;
      var datos = raiz.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (err) { return; }
      if (!variantes || !variantes.length) return;

      var inputId = raiz.querySelector('[data-mt-variant-id]');
      var boton = raiz.querySelector('[data-mt-boton]');
      var ahora = raiz.querySelector('[data-mt-precio-ahora]');
      var antes = raiz.querySelector('[data-mt-precio-antes]');
      var ahorro = raiz.querySelector('[data-mt-ahorro]');
      var textoDisponible = boton ? (boton.getAttribute('data-texto') || 'Añadir al carrito') : '';
      var textoAgotado = boton ? (boton.getAttribute('data-agotado') || 'Agotado') : '';
      var moneda = raiz.getAttribute('data-moneda') || '€';

      function fmt(centimos) {
        return (centimos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + moneda;
      }

      var grupos = raiz.querySelectorAll('[data-mt-opcion]');
      function seleccion() {
        var out = [];
        grupos.forEach(function (g) {
          var act = g.querySelector('[aria-pressed="true"]');
          out.push(act ? act.getAttribute('data-valor') : null);
        });
        return out;
      }

      function actualiza() {
        var sel = seleccion();
        var v = variantes.filter(function (x) {
          for (var i = 0; i < sel.length; i++) { if (sel[i] !== null && x.options[i] !== sel[i]) return false; }
          return true;
        })[0];

        grupos.forEach(function (g) {
          var etiqueta = g.querySelector('[data-mt-opcion-valor]');
          var act = g.querySelector('[aria-pressed="true"]');
          if (etiqueta) etiqueta.textContent = act ? act.getAttribute('data-valor') : '';
        });

        if (!v) {
          if (boton) { boton.disabled = true; boton.textContent = textoAgotado; }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (ahora) ahora.textContent = fmt(v.price);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            antes.textContent = fmt(v.compare_at_price);
            antes.hidden = false;
            if (ahorro) {
              ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
              ahorro.hidden = false;
            }
          } else {
            antes.hidden = true;
            if (ahorro) ahorro.hidden = true;
          }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.textContent = v.available ? textoDisponible : textoAgotado;
        }

        // la barra fija de compra sigue a la variante elegida
        var stPrecio = document.querySelector('[data-mt-sticky-precio]');
        var stOpc = document.querySelector('[data-mt-sticky-opciones]');
        var stBoton = document.querySelector('[data-mt-sticky-boton]');
        if (stPrecio) stPrecio.textContent = fmt(v.price);
        if (stOpc && v.options) stOpc.textContent = v.options.join(' · ');
        if (stBoton) {
          stBoton.disabled = !v.available;
          stBoton.textContent = v.available ? textoDisponible : textoAgotado;
        }
      }

      grupos.forEach(function (g) {
        g.querySelectorAll('.mt-pp__valor').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('.mt-pp__valor').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
            b.setAttribute('aria-pressed', 'true');
            actualiza();
          });
        });
      });
      actualiza();
    });
  }

  /* ------------------- carrito: aceptar términos antes de pagar (delegado,
     porque Dawn vuelve a dibujar el cajón cada vez que cambia el carrito) --- */
  function initTerminos() {
    if (window.__mtTerminos) return;
    window.__mtTerminos = true;

    /* La casilla y el botón viven dentro del mismo [data-mt-pago]. Sin ese
       ámbito, en la página del carrito se buscaba el botón por todo el
       documento y se acababa marcando el del cajón, no el de la página. */
    document.addEventListener('change', function (e) {
      var check = e.target.closest && e.target.closest('.mt-terminos__check');
      if (!check) return;
      var caja = check.closest('[data-mt-pago]');
      if (!caja) return;
      var boton = caja.querySelector('[data-mt-pagar]');
      var aviso = caja.querySelector('[data-mt-terminos-aviso]');
      if (check.checked) {
        if (boton) boton.removeAttribute('aria-disabled');
        if (aviso) aviso.hidden = true;
        var eti = check.closest('.mt-terminos');
        if (eti) eti.classList.remove('mt-aviso');
      } else {
        if (boton) boton.setAttribute('aria-disabled', 'true');
      }
    });

    // Si no está marcado, no dejamos salir hacia el pago
    document.addEventListener('click', function (e) {
      var boton = e.target.closest && e.target.closest('[data-mt-pagar]');
      if (!boton) return;
      var caja = boton.closest('[data-mt-pago]');
      if (!caja) return;
      var check = caja.querySelector('.mt-terminos__check');
      if (!check || check.checked) return;
      e.preventDefault();
      e.stopPropagation();
      var eti = check.closest('.mt-terminos');
      var aviso = caja.querySelector('[data-mt-terminos-aviso]');
      if (aviso) aviso.hidden = false;
      if (eti) {
        eti.classList.remove('mt-aviso');
        void eti.offsetWidth;
        eti.classList.add('mt-aviso');
        eti.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
      }
      check.focus();
    }, true);
  }

  /* ------------------------------ barra de compra fija (página de producto) */
  function initSticky() {
    var barra = document.querySelector('[data-mt-sticky]');
    if (!barra || !nuevo(barra)) return;
    var ancla = document.querySelector('[data-mt-form-ancla]');
    var botonReal = document.querySelector('[data-mt-boton]');
    var botonBarra = barra.querySelector('[data-mt-sticky-boton]');
    if (!ancla || !botonReal) return;

    if (botonBarra) {
      botonBarra.addEventListener('click', function () {
        if (botonReal.disabled) return;
        botonReal.click();
      });
    }

    function mostrar(si) {
      if (si) { barra.hidden = false; void barra.offsetWidth; barra.classList.add('mt-visible'); }
      else {
        barra.classList.remove('mt-visible');
        setTimeout(function () { if (!barra.classList.contains('mt-visible')) barra.hidden = true; }, reduce ? 0 : 400);
      }
    }

    // Basado en scroll a propósito: es determinista y funciona igual en
    // cualquier navegador, sin depender de que un observador se dispare.
    var ultimo = 0;
    var visible = false;
    function comprobar() {
      var r = ancla.getBoundingClientRect();
      // el botón real ya ha quedado por encima de la pantalla
      var pasado = r.bottom < 0;
      if (pasado === visible) return;
      visible = pasado;
      mostrar(pasado);
    }
    function alScroll() {
      var ahora = Date.now();
      if (ahora - ultimo < 90) return;
      ultimo = ahora;
      comprobar();
    }
    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', alScroll, { passive: true });
    comprobar();
  }

  /* -------------------------------------------- buscador en cajón lateral */
  function initBuscador() {
    var cajon = document.querySelector('.mt-busc');
    if (!cajon || !nuevo(cajon)) return;
    var velo = document.querySelector('.mt-busc__velo');
    var campo = cajon.querySelector('[data-mt-busc-campo]');
    var limpiar = cajon.querySelector('[data-mt-busc-limpiar]');
    var salida = cajon.querySelector('[data-mt-busc-resultados]');
    var inicio = cajon.querySelector('[data-mt-busc-inicio]');
    var abridores = document.querySelectorAll('[data-mt-abrir-buscador]');
    var cerradores = document.querySelectorAll('[data-mt-cerrar-buscador]');
    var temporizador = null;
    var ultimoFoco = null;

    function abrir() {
      ultimoFoco = document.activeElement;
      if (velo) velo.hidden = false;
      cajon.hidden = false;
      void cajon.offsetWidth;
      if (velo) velo.classList.add('mt-abierto');
      cajon.classList.add('mt-abierto');
      document.documentElement.classList.add('mt-menu-abierto');
      abridores.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { if (campo) campo.focus(); }, 260);
    }
    function cerrar() {
      if (velo) velo.classList.remove('mt-abierto');
      cajon.classList.remove('mt-abierto');
      document.documentElement.classList.remove('mt-menu-abierto');
      abridores.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      setTimeout(function () {
        if (!cajon.classList.contains('mt-abierto')) { cajon.hidden = true; if (velo) velo.hidden = true; }
      }, reduce ? 0 : 400);
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }

    abridores.forEach(function (b) { b.addEventListener('click', abrir); });
    cerradores.forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cajon.classList.contains('mt-abierto')) cerrar();
    });

    // El buscador devuelve el precio como TEXTO ya en euros ("62.90"),
    // mientras que /cart.js lo da en céntimos (6290). Aceptamos los dos.
    function dinero(valor) {
      if (valor === null || valor === undefined || valor === '') return '';
      var n = typeof valor === 'number'
        ? valor / 100
        : parseFloat(String(valor).replace(/[^\d.,-]/g, '').replace(',', '.'));
      if (isNaN(n)) return String(valor);
      return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function pinta(datos, consulta) {
      var productos = (datos && datos.resources && datos.resources.results && datos.resources.results.products) || [];
      if (!productos.length) {
        salida.innerHTML = '<p class="mt-busc__vacio">' + txt('busqVacia', 'No hemos encontrado nada para «@@». Prueba con otra palabra.', { '@@': consulta.replace(/[<>&]/g, '') }) + '</p>';
        return;
      }
      var html = '';
      productos.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        var precio = dinero(p.price);
        var antes = dinero(p.compare_at_price);
        if (antes && antes !== precio) precio += '<s>' + antes + '</s>';
        html += '<a class="mt-busc__fila" href="' + p.url + '">' +
                  '<span class="mt-busc__foto">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
                  '<span class="mt-busc__info">' +
                    '<span class="mt-busc__nombre">' + p.title + '</span>' +
                    '<span class="mt-busc__precio">' + precio + '</span>' +
                  '</span>' +
                '</a>';
      });
      html += '<a class="mt-busc__todos" href="/search?q=' + encodeURIComponent(consulta) + '">Ver todos los resultados</a>';
      salida.innerHTML = html;
    }

    function buscar(consulta) {
      salida.innerHTML = '<p class="mt-busc__cargando">Buscando…</p>';
      var url = '/search/suggest.json?q=' + encodeURIComponent(consulta) +
                '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { pinta(d, consulta); })
        .catch(function () {
          salida.innerHTML = '<p class="mt-busc__vacio">' + txt('busqError', 'No hemos podido buscar ahora mismo. Inténtalo otra vez.') + '</p>';
        });
    }

    if (campo) {
      campo.addEventListener('input', function () {
        var q = campo.value.trim();
        if (limpiar) limpiar.hidden = q.length === 0;
        clearTimeout(temporizador);
        if (q.length < 2) {
          salida.innerHTML = '';
          if (inicio) inicio.hidden = false;
          return;
        }
        if (inicio) inicio.hidden = true;
        temporizador = setTimeout(function () { buscar(q); }, 280);
      });
    }
    if (limpiar) {
      limpiar.addEventListener('click', function () {
        campo.value = '';
        limpiar.hidden = true;
        salida.innerHTML = '';
        if (inicio) inicio.hidden = false;
        campo.focus();
      });
    }
  }

  /* --------- buscador de la cabecera: resultados en vivo, como en móvil --- */
  function initBuscadorCabecera() {
    var form = document.querySelector('.mt-hd__buscar');
    if (!form || !nuevo(form)) return;
    var campo = form.querySelector('.mt-hd__campo');
    if (!campo) return;

    var panel = document.createElement('div');
    panel.className = 'mt-hd__resultados';
    panel.hidden = true;
    form.appendChild(panel);

    var temporizador = null;

    function dinero(valor) {
      if (valor === null || valor === undefined || valor === '') return '';
      var n = typeof valor === 'number'
        ? valor / 100
        : parseFloat(String(valor).replace(/[^\d.,-]/g, '').replace(',', '.'));
      if (isNaN(n)) return String(valor);
      return n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    function cerrar() { panel.hidden = true; panel.innerHTML = ''; }

    function pinta(datos, consulta) {
      var prods = (datos && datos.resources && datos.resources.results && datos.resources.results.products) || [];
      if (!prods.length) {
        panel.innerHTML = '<p class="mt-hd__vacio">' +
          txt('busqVacia', 'No hemos encontrado nada para «@@». Prueba con otra palabra.',
              { '@@': consulta.replace(/[<>&]/g, '') }) + '</p>';
        panel.hidden = false;
        return;
      }
      var html = '';
      prods.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        var precio = dinero(p.price);
        var antes = dinero(p.compare_at_price);
        if (antes && antes !== precio) precio += '<s>' + antes + '</s>';
        html += '<a class="mt-hd__res" href="' + p.url + '">' +
                  '<span class="mt-hd__res-foto">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
                  '<span class="mt-hd__res-info">' +
                    '<span class="mt-hd__res-nombre">' + p.title + '</span>' +
                    '<span class="mt-hd__res-precio">' + precio + '</span>' +
                  '</span>' +
                '</a>';
      });
      html += '<a class="mt-hd__res-todos" href="/search?q=' + encodeURIComponent(consulta) + '">Ver todos los resultados</a>';
      panel.innerHTML = html;
      panel.hidden = false;
    }

    campo.addEventListener('input', function () {
      var q = campo.value.trim();
      clearTimeout(temporizador);
      if (q.length < 2) { cerrar(); return; }
      temporizador = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
              { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) { pinta(d, q); })
          .catch(cerrar);
      }, 280);
    });

    campo.addEventListener('focus', function () {
      if (campo.value.trim().length >= 2 && panel.innerHTML) panel.hidden = false;
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) cerrar();
    });
    campo.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrar(); campo.blur(); }
    });
  }

  /* ------------------------------------------- selector de cantidad (± n) */
  function initCantidad() {
    if (window.__mtCantidad) return;
    window.__mtCantidad = true;

    function principal() { return document.querySelector('[data-mt-cant-input]:not([data-mt-cant-espejo])'); }

    function sincroniza(valor) {
      document.querySelectorAll('[data-mt-cant-input]').forEach(function (i) { i.value = valor; });
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-mt-cant]');
      if (!b) return;
      e.preventDefault();
      var caja = b.closest('[data-mt-cantidad]');
      var input = caja ? caja.querySelector('[data-mt-cant-input]') : principal();
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n)) n = 1;
      n = Math.max(1, n + parseInt(b.getAttribute('data-mt-cant'), 10));
      sincroniza(n);
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('[data-mt-cant-input]');
      if (!input) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      sincroniza(n);
    });
  }

  /* ------------------------------- guía de tallas: pestañas + recomendador */
  function initTallas() {
    document.querySelectorAll('[data-mt-tallas]').forEach(function (raiz) {
      if (!nuevo(raiz)) return;

      /* pestañas calzado / ropa */
      var pestanas = [].slice.call(raiz.querySelectorAll('[data-mt-tll-tab]'));
      pestanas.forEach(function (p) {
        p.addEventListener('click', function () {
          var destino = p.getAttribute('data-mt-tll-tab');
          pestanas.forEach(function (o) { o.setAttribute('aria-selected', o === p ? 'true' : 'false'); });
          raiz.querySelectorAll('[data-mt-tll-panel]').forEach(function (panel) {
            panel.classList.toggle('mt-tll__panel--activo', panel.getAttribute('data-mt-tll-panel') === destino);
          });
        });
      });

      /* recomendador */
      var reco = raiz.querySelector('[data-mt-reco]');
      if (!reco) return;
      var elLargo = reco.querySelector('[data-mt-reco-largo]');
      var elAncho = reco.querySelector('[data-mt-reco-ancho]');
      var boton = reco.querySelector('[data-mt-reco-calcular]');
      var salida = reco.querySelector('[data-mt-reco-salida]');
      var tabla = raiz.querySelector('[data-mt-tabla-calzado]');
      if (!elLargo || !boton || !salida || !tabla) return;

      var tallas = [].slice.call(tabla.querySelectorAll('tbody tr')).map(function (tr) {
        return {
          eu: tr.getAttribute('data-eu'),
          us: tr.getAttribute('data-us'),
          largo: parseFloat(tr.getAttribute('data-largo')),
          fila: tr
        };
      }).filter(function (t) { return !isNaN(t.largo); })
        .sort(function (a, b) { return a.largo - b.largo; });

      var umbral = parseFloat(reco.getAttribute('data-umbral') || '100') / 100;

      function limpiaMarcas() {
        tallas.forEach(function (t) { t.fila.classList.remove('mt-tll__fila--elegida'); });
      }

      function pinta(html, tono) {
        salida.className = 'mt-tll__resultado' + (tono ? ' mt-tll__resultado--' + tono : '');
        salida.innerHTML = html;
        salida.hidden = false;
      }

      function calcular() {
        var valor = parseFloat(String(elLargo.value).replace(',', '.'));
        limpiaMarcas();

        if (isNaN(valor) || valor <= 0) {
          pinta('<p class="mt-tll__res-txt">' + txt('tallaEscribe', 'Escribe el largo de tu pie en centímetros.') + '</p>', 'aviso');
          elLargo.focus();
          return;
        }
        if (valor < tallas[0].largo) {
          pinta('<p class="mt-tll__res-txt">' +
                txt('tallaMenor', 'Tu medida (@@ cm) es menor que nuestra talla más pequeña (##).',
                    { '@@': num(valor.toFixed(1)), '##': tallas[0].eu }) +
                '</p>', 'aviso');
          return;
        }
        if (valor > tallas[tallas.length - 1].largo) {
          /* fallo típico: escribir la medida en milímetros (243 en vez de 24,3) */
          var enMm = valor > 100;
          pinta('<p class="mt-tll__res-txt">' +
                txt('tallaMayor', 'Tu medida (@@ cm) supera nuestra talla más grande (##).',
                    { '@@': num(valor.toFixed(1)), '##': tallas[tallas.length - 1].eu }) +
                ' ' + (enMm ? txt('tallaMm', 'Si la has apuntado en milímetros, escríbela en centímetros.')
                             : txt('tallaContacto', 'Escríbenos y lo miramos contigo.')) +
                '</p>', 'aviso');
          return;
        }

        // la primera talla cuyo largo llega a la medida del pie
        var elegida = null;
        for (var i = 0; i < tallas.length; i++) {
          if (tallas[i].largo >= valor - 0.001) { elegida = tallas[i]; break; }
        }
        if (!elegida) elegida = tallas[tallas.length - 1];

        /* La columna de la tabla es el largo de pie para el que está hecha
           la talla, así que "holgura 0" es un acierto pleno, no un zapato justo. */
        var holgura = (elegida.largo - valor);
        var comentario;
        if (holgura <= 0.1) {
          comentario = txt('tallaExacta', 'Es justo la medida para la que está hecha esa talla.');
        } else {
          var mm = Math.round(holgura * 10);
          comentario = mm === 1
            ? txt('tallaSobraUno', 'Te sobra 1 mm, que es la holgura cómoda para bailar.')
            : txt('tallaSobra', 'Te sobran unos @@ mm, que es la holgura cómoda para bailar.', { '@@': mm });
        }
        var siguiente = tallas[tallas.indexOf(elegida) + 1];
        if (holgura <= 0.1 && siguiente) {
          comentario += ' ' + txt('tallaSiguiente', 'Si te gustan un pelín más sueltos, pide la @@.', { '@@': siguiente.eu });
        }

        var html = '<div class="mt-tll__res-cab">' +
                     '<span class="mt-tll__res-eti">' + txt('tallaEti', 'Tu talla') + '</span>' +
                     '<span class="mt-tll__res-eu">' + elegida.eu + '</span>' +
                     (elegida.us ? '<span class="mt-tll__res-us">US ' + elegida.us + '</span>' : '') +
                   '</div>' +
                   '<p class="mt-tll__res-txt">' +
                     txt('tallaHechaPara', 'Esa talla está hecha para un pie de @@ cm.',
                         { '@@': num(elegida.largo) }) +
                     ' ' + comentario +
                   '</p>';

        // contorno opcional
        var ancho = parseFloat(String(elAncho && elAncho.value ? elAncho.value : '').replace(',', '.'));
        if (!isNaN(ancho) && ancho > 0) {
          if (ancho / valor >= umbral) {
            html += '<p class="mt-tll__res-txt mt-tll__res-ancho">' + txt('anchoAmplio', 'Tu contorno es amplio para ese largo.') + '</p>';
          } else {
            html += '<p class="mt-tll__res-txt mt-tll__res-ancho">' + txt('anchoOk', 'Tu contorno entra dentro del ancho estándar.') + '</p>';
          }
        }

        pinta(html, 'ok');
        elegida.fila.classList.add('mt-tll__fila--elegida');
        if (!reduce) elegida.fila.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      boton.addEventListener('click', calcular);
      [elLargo, elAncho].forEach(function (el) {
        if (!el) return;
        el.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calcular(); } });
      });
    });
  }

  /* ---- añadir al carrito sin salir de la página: abre el cajón lateral ---- */
  function initAnadirAjax() {
    if (window.__mtAnadir) return;
    window.__mtAnadir = true;

    function actualizaContadores() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-mt-cuenta-carrito]').forEach(function (g) {
            g.textContent = c.item_count;
            g.hidden = c.item_count === 0;
          });
        })
        .catch(function () {});
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var accion = form.getAttribute('action') || '';
      if (accion.indexOf('/cart/add') === -1) return;
      if (!form.closest('[data-mt-producto]')) return;

      var cajon = document.querySelector('cart-drawer');
      if (!cajon || typeof cajon.renderContents !== 'function') return; // sin cajón, comportamiento normal

      e.preventDefault();

      var boton = form.querySelector('[data-mt-boton]');
      var textoOriginal = boton ? boton.textContent : '';
      if (boton) { boton.disabled = true; boton.textContent = boton.getAttribute('data-cargando') || 'Añadiendo…'; }

      var aRenderizar = cajon.getSectionsToRender().map(function (s) { return s.id; });

      /* Complementos marcados: si hay alguno, se manda todo junto como lista de
         artículos. El formulario normal solo sabe añadir uno. */
      var extras = [];
      var seccion = form.closest('[data-mt-producto]');
      if (seccion) {
        seccion.querySelectorAll('[data-mt-upsell]').forEach(function (fila) {
          var casilla = fila.querySelector('[data-mt-ups-check]');
          var variante = fila.querySelector('[data-mt-ups-variante]');
          if (!casilla || !casilla.checked || !variante || !variante.value) return;
          extras.push({ id: parseInt(variante.value, 10), quantity: 1 });
        });
      }

      var peticion;
      if (extras.length) {
        var campoId = form.querySelector('[data-mt-variant-id]');
        var campoCant = form.querySelector('[name="quantity"]');
        var articulos = [{
          id: parseInt(campoId ? campoId.value : 0, 10),
          quantity: parseInt(campoCant ? campoCant.value : 1, 10) || 1
        }].concat(extras);

        peticion = fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: articulos,
            sections: aRenderizar,
            sections_url: window.location.pathname
          })
        });
      } else {
        var datos = new FormData(form);
        datos.append('sections', aRenderizar.join(','));
        datos.append('sections_url', window.location.pathname);
        peticion = fetch('/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: datos
        });
      }

      peticion
        .then(function (r) { return r.json(); })
        .then(function (respuesta) {
          if (respuesta.status) {
            // el producto no se pudo añadir (sin stock, variante no válida…)
            if (boton) boton.textContent = respuesta.description || respuesta.message || 'No disponible';
            setTimeout(function () {
              if (boton) { boton.textContent = textoOriginal; boton.disabled = false; }
            }, 2200);
            return;
          }
          cajon.renderContents(respuesta); // dibuja el cajón Y lo abre

          /* Dawn quita la clase 'is-empty' de .drawer__inner, pero la clase
             vive en <cart-drawer>. Si no se limpia, el cajón se queda con los
             estilos de "carrito vacío": sin márgenes y con la lista escondida. */
          cajon.classList.remove('is-empty');
          var interior = cajon.querySelector('.drawer__inner');
          if (interior) interior.classList.remove('is-empty');

          /* Los complementos ya están dentro: se desmarcan para que un segundo
             clic en "Añadir" no los duplique sin querer. */
          if (seccion) {
            seccion.querySelectorAll('[data-mt-ups-check]').forEach(function (c) { c.checked = false; });
          }

          actualizaContadores();
          if (boton) { boton.textContent = textoOriginal; boton.disabled = false; }
        })
        .catch(function () {
          // si algo falla, dejamos que el navegador haga el envío de siempre
          if (boton) { boton.textContent = textoOriginal; boton.disabled = false; }
          form.submit();
        });
    });
  }

  /* ------- complementos: el precio sigue a la variante que se elige --------- */
  function initComplementos() {
    if (window.__mtUpsell) return;
    window.__mtUpsell = true;

    function pintaPrecio(sel) {
      var fila = sel.closest('[data-mt-upsell]');
      var precio = fila && fila.querySelector('[data-mt-ups-precio]');
      var op = sel.options[sel.selectedIndex];
      if (precio && op) precio.textContent = op.getAttribute('data-precio') || precio.textContent;
    }

    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-mt-ups-variante]');
      if (!sel || sel.tagName !== 'SELECT') return;
      sel.setAttribute('data-tocado', '1'); // ya lo ha elegido a mano: no lo tocamos más
      pintaPrecio(sel);
      /* elegir una talla es señal de que lo quiere: se marca la casilla sola */
      var fila = sel.closest('[data-mt-upsell]');
      var casilla = fila && fila.querySelector('[data-mt-ups-check]');
      if (casilla) casilla.checked = true;
    });

    /* Los protectores de tacón usan los mismos valores que la variante de Tacón
       ("7.5cm Cubano"), así que al elegir el tacón se preselecciona el protector
       que toca. Si el cliente ya lo cambió a mano, se respeta. */
    document.addEventListener('click', function (e) {
      var opcion = e.target.closest && e.target.closest('[data-mt-opcion] [data-valor]');
      if (!opcion) return;
      var seccion = opcion.closest('[data-mt-producto]');
      if (!seccion) return;

      setTimeout(function () {
        var elegidos = [];
        seccion.querySelectorAll('[data-mt-opcion] [aria-pressed="true"]').forEach(function (b) {
          var v = b.getAttribute('data-valor');
          if (v) elegidos.push(v.trim().toLowerCase());
        });
        if (!elegidos.length) return;

        seccion.querySelectorAll('select[data-mt-ups-variante]').forEach(function (sel) {
          if (sel.getAttribute('data-tocado')) return;
          for (var i = 0; i < sel.options.length; i++) {
            var etiqueta = sel.options[i].textContent.trim().toLowerCase();
            for (var j = 0; j < elegidos.length; j++) {
              if (etiqueta.indexOf(elegidos[j]) === 0) {
                sel.selectedIndex = i;
                pintaPrecio(sel);
                return;
              }
            }
          }
        });
      }, 0);
    });
  }

  /* ------------------- pop-ups con <dialog> (envíos, avisos…) -------------- */
  function initPopups() {
    if (window.__mtPopups) return;
    window.__mtPopups = true;

    document.addEventListener('click', function (e) {
      var abre = e.target.closest && e.target.closest('[data-mt-abrir-popup]');
      if (abre) {
        var dlg = document.getElementById(abre.getAttribute('data-mt-abrir-popup'));
        if (dlg && typeof dlg.showModal === 'function') {
          e.preventDefault();
          dlg.showModal();
        }
        return;
      }

      var cierra = e.target.closest && e.target.closest('[data-mt-cerrar-popup]');
      if (cierra) {
        var suyo = cierra.closest('dialog');
        if (suyo) suyo.close();
        return;
      }

      /* clic en el fondo oscuro: el propio <dialog> recibe el clic cuando se
         pincha fuera de su contenido */
      if (e.target.tagName === 'DIALOG' && e.target.classList.contains('mt-popup')) {
        e.target.close();
      }
    });
  }

  /* ---- en escritorio, la línea de envío se mete junto a las garantías ----- */
  function initEnvioColumna() {
    var todas = document.querySelectorAll('[data-mt-env-columna]');
    if (!todas.length) return;

    /* Movemos el envoltorio #shopify-section-…, no la <section> de dentro.
       Si movemos solo el interior, el editor vuelve a rellenar el envoltorio
       que se quedó en su sitio y aparece la línea duplicada. */
    var interior = todas[todas.length - 1];
    var seccion = interior.closest('.shopify-section') || interior;

    /* por si una edición anterior dejó copias huérfanas */
    for (var i = 0; i < todas.length - 1; i++) {
      var vieja = todas[i].closest('.shopify-section') || todas[i];
      if (vieja !== seccion && vieja.parentNode) vieja.parentNode.removeChild(vieja);
    }

    /* marca en el sitio original, para devolverla ahí en móvil */
    var marca = document.querySelector('[data-mt-env-sitio]');
    if (!marca) {
      marca = document.createElement('div');
      marca.setAttribute('data-mt-env-sitio', '');
      marca.hidden = true;
      seccion.parentNode.insertBefore(marca, seccion);
    }

    var garantias = document.querySelector('[data-mt-producto] .mt-pp__garantias');
    if (!garantias) return;

    /* matchMedia y no 'resize': salta justo en el punto de corte y también
       cuando se gira el móvil, sin tener que ir midiendo en cada píxel. */
    var escritorio = window.matchMedia('(min-width: 990px)');

    function coloca() {
      if (escritorio.matches) {
        if (seccion.parentNode !== garantias.parentNode) {
          garantias.parentNode.insertBefore(seccion, garantias.nextSibling);
        }
      } else if (seccion.previousElementSibling !== marca) {
        marca.parentNode.insertBefore(seccion, marca.nextSibling);
      }
    }

    coloca();

    /* un solo oyente aunque el editor vuelva a llamar a esta función */
    if (!window.__mtEnvMedia) {
      window.__mtEnvMedia = true;
      var alCambiar = function () { initEnvioColumna(); };
      if (typeof escritorio.addEventListener === 'function') {
        escritorio.addEventListener('change', alCambiar);
      } else {
        escritorio.addListener(alCambiar); // Safari viejo
      }
    }
  }


  /* ------------------------------------------------------------------
     Selector de idioma flotante: <details> se abre solo, pero no se
     cierra al pulsar fuera. Eso lo ponemos aquí.
     ------------------------------------------------------------------ */
  function initIdiomaFlotante() {
    var cajas = document.querySelectorAll("[data-mt-idflot], [data-mt-idioma-cab]");
    if (!cajas.length) return;
    document.addEventListener("click", function (e) {
      for (var i = 0; i < cajas.length; i++) {
        if (cajas[i].open && !cajas[i].contains(e.target)) cajas[i].open = false;
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      for (var i = 0; i < cajas.length; i++) cajas[i].open = false;
    });
  }

  /* ------------ el carrito de la barra móvil abre el cajón, no la página --- */
  function initCarritoCajon() {
    if (window.__mtCarritoCajon) return;
    window.__mtCarritoCajon = true;

    document.addEventListener('click', function (e) {
      var boton = e.target.closest && e.target.closest('[data-mt-abrir-carrito]');
      if (!boton) return;
      var cajon = document.querySelector('cart-drawer');
      if (cajon && typeof cajon.open === 'function') {
        e.preventDefault();
        cajon.open(boton);
      }
      // si no hay cajón, el enlace sigue su curso hacia /cart
    });
  }

  /* -------------------------------------------------------------------- init */
  function initTodo() {
    initReveals();
    initCarruseles();
    initTacon();
    initAnatomia();
    initCifras();
    initQuiz();
    initFaq();
    initMagnetico();
    initGaleria();
    initVariantes();
    initApp();
    initTerminos();
    initSticky();
    initBuscador();
    initComplementos();
    initPopups();
    initEnvioColumna();
    initIdiomaFlotante();
    initCarritoCajon();
    initCantidad();
    initBuscadorCabecera();
    initAnadirAjax();
    initTallas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodo);
  } else {
    initTodo();
  }
  // El editor de Shopify re-renderiza secciones sin recargar la página
  document.addEventListener('shopify:section:load', initTodo);
})();
